import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { RootState } from '../redux/store';
import { setPatientType } from '../redux/slices/appointmentSlice';
import { StepCard } from '../components/StepCard';
import { Button } from '../components/Button';
import { StepActions } from '../components/StepActions';
import { PatientTypeEnum } from '../types';
import { WelcomeMessage } from '../components/common/WelcomeMessage';

export const StepPatientType = () => {
  const selectedPatientType = useSelector((s: RootState) => s.appointment.patientType);
  const { practice } = useSelector((s: RootState) => s.auth);
  const showWelcomeMessage = practice?.show_welcome_message && practice?.welcome_message;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const proceed = () => navigate(`../step-2`);

  return (
    <Layout>
      <div className="space-y-4">
        <div className='flex flex-col items-center text-center md:items-start md:text-start'>
          <h1 className="text-2xl font-semibold text-black">Patient type</h1>
          <p className="text-sm text-gray-500">Are you a new patient or have you visited us before?</p>
        </div>
        {showWelcomeMessage && (
          <WelcomeMessage message={practice?.welcome_message || ''} />
        )}
        <StepCard className={showWelcomeMessage ? '!h-[380px]' : ''}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-black">
            {Object.values(PatientTypeEnum).map((t) => (
              <button
                key={t}
                onClick={() => dispatch(setPatientType(t))}
                className={`card bg-white shadow-sm p-6 border rounded-lg ${selectedPatientType === t ? 'border-teamcare-blue ring-2 ring-teamcare-blue/20' : 'border-gray-200'}`}
              >
                <div className="text-center font-medium capitalize">{t} patient</div>
              </button>
            ))}
          </div>
        </StepCard>
        <StepActions className="justify-end">
          <Button title='Continue' disabled={!selectedPatientType} onClick={proceed} />
        </StepActions>
      </div>
    </Layout>
  );
};
